"use client";

import Link from "@/components/Link";
import Text from "@/components/Text";
import { useStallContext } from "@/tools/medusa";

export interface ProductBackLinkProps {
  defaultHref: string;
  defaultLabel: string;
  className?: string;
}

const ProductBackLink = ({ defaultHref, defaultLabel, className }: ProductBackLinkProps) => {
  const stallContext = useStallContext();

  const href = stallContext ? `/gift-stalls/${stallContext.slug}/` : defaultHref;
  const label = stallContext ? `Back to ${stallContext.stallName}` : defaultLabel;

  return (
    <Link
      href={href}
      className={className}
      variant="content"
      size="none"
      icon="triangleLeft"
      iconPosition="left"
      iconHover
    >
      <Text text={label} variant="label" size="md" weight="semibold" />
    </Link>
  );
};

export default ProductBackLink;
